
import React from "react";
import {Col, Container, Row} from "react-bootstrap";

function IndicatorConfigView(params) {
    const indicator = params.config != null && params.config.indicatorConfig != null ? params.config.indicatorConfig : {name:'unknown'}
    return <div className="press-grid">
        <Container>
            <Row>
                <Col>Indicator</Col>
                <Col>Type</Col>
                <Col>High</Col>
                <Col>Low</Col>
                <Col>Repeat Count</Col>
            </Row>
            <Row>
                <Col>{indicator.name}</Col>
                <Col>{indicator.type}</Col>
                <Col>{indicator.highThreshold}</Col>
                <Col>{indicator.lowThreshold}</Col>
                <Col>{indicator.repeatCount}</Col>
            </Row>
        </Container>
    </div>;
}

export {IndicatorConfigView}
